export class LookUpModel{
    public ID:string;
    public Name:string;
    public constructor(){
        this.ID="";
        this.Name="";
    }
}